import CountriesModel from "../models/countries/CountriesModel";

export const getByShortcode = (countries: CountriesModel[], shortcode: string) => {
    return countries.find(country => country.shortcut === shortcode);
};

export const getDefaultVat = (countries: CountriesModel[], defaultCountryCode: string = "DE") => {
    const defaultCountry = getByShortcode(countries, defaultCountryCode);
    if (defaultCountry) {
        return defaultCountry.vat;
    }
    return 0;
};

export const isEuCountry = (countries: CountriesModel[], countryName): boolean => {
    const countryInfo = countries.find(country => country.name === countryName);
    return countryInfo?.euCountry;
};